import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { CookieService } from 'ngx-cookie-service';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reading-list',
  templateUrl: './reading-list.component.html',
  styleUrls: ['./reading-list.component.css']
})
export class ReadingListComponent implements OnInit {
  private readonly notifier: NotifierService;
  constructor(@Inject(DOCUMENT) private document: Document, private activatedRoute: ActivatedRoute, private homepageService: HomepageService, private cookieService: CookieService, notifierService: NotifierService) { 
    this.notifier = notifierService;
  }
	readingList: any = [];
	responseAPIstatus: boolean = true;
  loginUser: string = '';
  loginUserPermission: boolean = false;
  editingResource: boolean = false;
  fileToUpload: File = null;
  curentLoc:any = [];
  totalLocations: number = 0;
  exploreId: any;
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.exploreId = params['exp-btn-id'];
    });
  	this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('list');
  	this.getReadinlist();
    if(this.cookieService.check('patronPermissions')) {
      var userPermission = JSON.parse(this.cookieService.get('patronPermissions'));
      if(userPermission.opacAdmin && userPermission.opacPublishResourceList){
        this.loginUserPermission =true;
      }    
    }

    this.homepageService.getConfig().subscribe((data) => {
      var tenant = data.data.tenantCode.toLowerCase(); 
      var selectedId =  this.cookieService.get('selectedlocation'+tenant)
    //console.log('location', selectedId);  
      this.totalLocations = data.data.settings.location.locations.length;
      data.data.settings.location.locations.forEach( (loc) => {
        if(loc.id == selectedId){
          this.curentLoc['id'] = loc.id;
          this.curentLoc['name'] = loc.name;
        }
      });
    });
  }

  getReadinlist() {
    this.responseAPIstatus = true;  
	  return this.homepageService.getReadinlist(this.exploreId).subscribe((data) => {
    	this.readingList = data;  
    	this.responseAPIstatus = false;  
    });


  }

  editResourceList(event,id)
  {
    this.editingResource = true;
    var title = $('div#add-resource'+id).find('input[name="title"]').val();
    var content = $('div#add-resource'+id).find('textarea[name="content"]').val();
    var image = $('div#add-resource'+id).find('input[name="image"]').val();
    var loations =  $('div#add-resource'+id).find('input[name="selectLocation'+id+'"]:checked').val();
    var published =  true;
    var allLocation = false;
    if(loations == ''){
      //loations = null;
      allLocation = true;
    }
    if(loations == 'unpublished'){
      //loations = $('div#add-resource'+id).find('input[name="selectLocation'+id+'"]:first-child').val();
      published = false;
    }
    var auth = localStorage.getItem('token');
    //console.log('location', loations);
    //console.log('publish', published);
    //return false;
    this.homepageService.editResourseList(id,title,content,image,allLocation,published,auth).subscribe((data) => {
      this.homepageService.getReadinlist().subscribe((data1) => {
        this.readingList = data1;  
        this.responseAPIstatus = false;  
        this.editingResource = false;
        $(event.target).parents('.modal').find('#closeBulletinAdd').trigger('click');
      });
    }); 
  }


 uploadImage(files: FileList, id) {
    this.editingResource = true;
    this.fileToUpload = files.item(0); 
    let formData = new FormData(); 
    formData.append('file', this.fileToUpload, this.fileToUpload.name); 
    var token =  localStorage.getItem('token');
    this.homepageService.readingListImageUpload(formData, token).subscribe((data : any) => { 
           this.editingResource = false;
      $('div#add-resource'+id).find('input[name="image"]').attr('value',data.data.url);
      $('div#add-resource'+id).find('img.regularImage').attr('src',data.data.url);
    });
   }

   deleteresource(event,id){    
      if(confirm('Are you sure?')){
        this.editingResource = true;
        var token =  localStorage.getItem('token');
         this.homepageService.deleteReadingList(id, token).subscribe(
          (data) => {
          //console.log(data, '+++++++++++++');
          if(data.status){
            this.editingResource = false;
            $(event.target).parents('.modal').find('#closeBulletinAdd').trigger('click');
            this.homepageService.getReadinlist().subscribe((data1) => {
                this.readingList = data1;  
            });
          }else{
            this.editingResource = false;
            $(event.target).parents('.modal').find('#closeBulletinAdd').trigger('click');
            this.notifier.notify( 'error', 'Something went wrong.' );
          }
        },
        (error)=>{
          this.editingResource = false;
          $(event.target).parents('.modal').find('#closeBulletinAdd').trigger('click');
          this.notifier.notify( 'error', 'Something went wrong.' );
        });    
      }
   }

   unpublishResource(event,id){
      if(confirm('Are you sure?')){
        var token =  localStorage.getItem('token');
         this.homepageService.unpublishReadingList(id, token).subscribe((data) => {
          this.homepageService.getReadinlist().subscribe((data1) => {
              this.readingList = data1;  
          });  
        });    
      }
   }
}
